<script>
import { required } from 'vuelidate/lib/validators'
import WorldMapAlarms from './world_map_alarms.vue'
import SearchInput from '@components/search-input.vue'
import SearchDateTime from '@components/search-datetime.vue'

import axios from 'axios'

export default {
  components: {
    WorldMapAlarms,
    SearchInput,
    SearchDateTime,
  },
  filters: {
    pretty: function(value) {
      return JSON.stringify(JSON.parse(value), null, 2)
    },
  },
  props: {
    url: {
      type: String,
      default: '/entra_id/risks/list?altorder=activityDateTime&direction=desc',
    },
  },
  data() {
    return {
      appConfig: {},
      showDownloadCSVButton: false,
      category: 'List',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Entra ID Risks',
          active: true,
        },
      ],
      appConfig:
        process.env.NODE_ENV === 'production'
          ? require('@src/app.config')
          : require('@src/app.config.dev'),
      risk: {},
      events: [],
      locations: [],
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: '',
      fieldsFilter: '',
      // filterOn: [],
      sortBy: 'CreationTime',
      sortDesc: true,
      alarmDetailsFull: false,
      searchFields: '',
      showSearchByFields: true, // Cambiar a true para activar cambio de filtrado
      tableDetailFields: [
        { key: 'label', label: 'Field' },
        { key: 'visible', label: 'Visible' },
      ],
      fields: [
        {
          key: 'riskLevel',
          field: 'riskLevel',
          label: 'Risk',
          sortable: false,
          visible: true,
        },
        {
          key: 'riskEventType',
          field: 'riskEventType',
          label: 'Type',
          sortable: false,
          visible: true,
        },
        {
          key: 'riskState',
          field: 'riskState',
          label: 'State',
          sortable: false,
          visible: true,
        },
        {
          key: 'activity',
          field: 'activity',
          label: 'Activity',
          sortable: false,
          visible: true,
        },
        {
          key: 'userPrincipalName',
          field: 'userPrincipalName',
          label: 'User',
          control: 'SearchInput',
          sortable: true,
          visible: true,
        },
        {
          key: 'activityDateTime',
          field: 'activityDateTime',
          label: 'Time',
          sortable: true,
          visible: true,
        },
        {
          key: 'ipAddress',
          field: 'ipAddress',
          label: 'IP',
          control: 'SearchInput',
          sortable: false,
          visible: false,
        },
        { key: 'action', label: 'Action', sortable: false, visible: true },
      ],
      allFields: [
        {
          key: 'riskLevel',
          field: 'riskLevel',
          label: 'Risk',
          sortable: false,
          visible: true,
        },
        {
          key: 'riskEventType',
          field: 'riskEventType',
          label: 'Type',
          sortable: false,
          visible: true,
        },
        {
          key: 'riskState',
          field: 'riskState',
          label: 'State',
          sortable: false,
          visible: true,
        },
        {
          key: 'activity',
          field: 'activity',
          label: 'Activity',
          sortable: false,
          visible: true,
        },
        {
          key: 'userPrincipalName',
          field: 'userPrincipalName',
          control: 'SearchInput',
          label: 'User',
          sortable: true,
          visible: true,
        },
        {
          key: 'activityDateTime',
          field: 'activityDateTime',
          label: 'Time',
          sortable: true,
          visible: true,
        },
        {
          key: 'ipAddress',
          field: 'ipAddress',
          label: 'IP',
          control: 'SearchInput',
          sortable: false,
          visible: false,
        },
      ],
      fieldsMapping: {
        type: 'type',
        target: 'target',
        ip: 'raw_events.ClientIP',
      },
      isBusy: true,
      searches: {},
      searchType: 'rawsearch',
    }
  },
  validations: {
    event: {
      title: { required },
      category: { required },
    },
  },
  computed: {
    rows() {
      return this.totalRows || 0
    },
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.loadData(this.filter)
      },
    },
    perPage: {
      handler: function(value) {
        this.loadData(this.filter)
      },
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData(query = '') {
      const that = this
      that.showDownloadCSVButton = false
      that.isBusy = true
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const searchType = this.searchType
      const countURL =
        query.length < 1
          ? `${baseURL}${that.url}&count=yes`
          : `${baseURL}${that.url}&${searchType}=${query}&count=yes`

      axios
        .get(countURL)
        .then((response) => {
          that.totalRows = parseInt(response.data)
        })
        .catch(function(error) {})
      let dataURL =
        query.length < 1
          ? `${baseURL}${that.url}&page=${that.currentPage}&page_size=${
              that.perPage
            }`
          : `${baseURL}${that.url}&page=${that.currentPage}&page_size=${
              that.perPage
            }&${searchType}=${query}`
      axios
        .get(dataURL)
        .then((response) => {
          if (response.status === 200) {
            that.isBusy = false
            that.tableData = response.data
          }
          that.showDownloadCSVButton = true
        })
        .catch(function(error) {})
    },
    generateCSV() {
      const that = this
      const separator = ';'
      const inKeys = [
        'severity',
        'type',
        'target',
        'detected',
        'start',
        'end',
        'message',
        'events',
      ]
      const outKeys = [
        'severity',
        'type',
        'target',
        'detected',
        'start',
        'end',
        'message',
        'events',
      ]
      const eventKeysIn = [
        'AppName',
        'Operation',
        'ResultStatus',
        'intelligence.geoip.country_name',
        'intelligence.geoip.city',
        'intelligence.geoip.ip',
        'intelligence.geoip.connection.asn',
        'CreationTime.$date',
      ]
      const eventKeysOut = {
        AppName: 'App Name',
        Operation: 'Operation',
        ResultStatus: 'Result Status',
        'intelligence.geoip.country_name': 'Country',
        'intelligence.geoip.city': 'City',
        'intelligence.geoip.ip': 'IP',
        'intelligence.geoip.connection.asn': 'ASN',
        'CreationTime.$date': 'Creation Time',
      }

      const headers = outKeys.join(separator) + '\n'
      let payload = that.tableData
        .map((entry) => {
          let procLine = inKeys
            .map((key) => {
              if (key !== 'events') {
                return entry[key] || ''
              } else {
                const rawEvents = entry[key] || []
                let eventC = 0

                const events = rawEvents.map((event) => {
                  const joinedEvent = eventKeysIn.map((eventKeyIn) => {
                    let e = ''
                    try {
                      e =
                        eventKeyIn.split('.').reduce((o, i) => o[i], event) ||
                        ''
                    } catch (err) {}
                    return ` ${eventKeysOut[eventKeyIn]}: ${e}`
                  })
                  eventC += 1
                  return ` Event ${eventC} => ${joinedEvent}`
                })
                return events
              }
            })
            .join(separator)
          return procLine
        })
        .join('\n')
      const csvContent = 'data:text/csv;charset=utf-8,' + headers + payload

      return csvContent
    },
    downloadCSV() {
      const that = this
      const content = that.generateCSV()
      let encodedUri = encodeURI(content)
      window.open(encodedUri)
    },
    async downloadCSVFull() {
      const that = this
      try {
        const baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
        const response = await axios.get(
          `${baseURL}/entra_id/risks/list/csv?limit=2000&altorder=activityDateTime&direction=desc`,
          {
            responseType: 'blob',
          }
        )

        const blob = new Blob([response.data], {
          type: 'text/csv;charset=utf-8;',
        })

        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)

        link.setAttribute('href', url)
        link.setAttribute('download', 'entra_id_risks.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Error downloading the CSV file:', error)
      }
    },
    modalIncidentDetailOk() {
      this.risk = {}
      this.events = []
      this.locations = []
    },
    showDetails(data) {
      if (data === undefined || data.item === undefined) return
      this.risk = data.item
      this.$refs['modal-details'].show()
    },
    doSearch() {
      this.searchType = 'rawsearch'
      let filter = this.filter
      if (filter.length !== undefined) {
        this.loadData(filter)
      }
    },
    configTable() {
      this.$refs['modal-table-config'].show()
    },
    toggleVisibleColumn(data, selected) {
      const that = this
      const visible = selected.visible // Arregló el problema que se presentaba con la interfaz

      if (visible) {
        if (
          that.fields.filter((field) => field.label === selected.label)
            .length === 0
        ) {
          let newFields = []
          that.allFields.forEach((af) => {
            if (af.label === selected.label) {
              newFields.push(selected)
            } else {
              if (
                that.fields.filter(
                  (field) => field.label === af.label && field.visible
                ).length > 0
              ) {
                newFields.push(af)
              }
            }
          })
          newFields.push({ key: 'action', sortable: false })
          that.fields = newFields
        }
      } else {
        if (
          that.fields.filter((field) => field.label === selected.label).length >
          0
        ) {
          let newFields = that.fields
          if (that.fields.length > 2)
            that.fields = newFields.filter(
              (field) => field.label !== selected.label
            )
          if (that.fieldsMapping[selected.key] !== undefined) {
            delete that.searches[that.fieldsMapping[selected.key]]
            that.doSearchInput()
          }
        }
      }
    },
    modalTableDetaillOk() {},
    aggEvents() {
      const that = this
      const ips = [...new Set(that.events.map((event) => event.ClientIP))]
      let agg = []
      ips.forEach((ip) => {
        let entries = that.events.filter((event) => event.ClientIP === ip)
        let count = entries.length
        let entryDetail = entries[0]
        entryDetail['events'] = count
        agg.push(entryDetail)
      })
      return agg
    },
    generateFilterFromFields() {
      const that = this
      let filter = ''
      Object.keys(that.searches).map((key) => {
        if (that.searches[key] !== undefined && that.searches[key].length > 0) {
          filter += `${key}:${that.searches[key]},`
        }
      })
      return filter.substring(0, filter.length - 1)
    },
    doSearchInput() {
      this.currentPage = 1
      this.searchType = 'mfsearch'
      this.fieldsFilter = this.generateFilterFromFields()
      if (this.fieldsFilter.length !== undefined) {
        this.loadData(this.fieldsFilter)
      }
    },
    fieldSearchChanged(desc, field, text) {
      this.searches[field] = text.trim()
    },
    datetimeSearchChanged(desc, field, datetime) {
      this.searches[field] = datetime
    },
    handlePageChange(page) {
      this.currentPage = page
      this.searchType = 'mfsearch'
      this.fieldsFilter = this.generateFilterFromFields()
      if (this.fieldsFilter.length !== undefined) {
        this.loadData(this.fieldsFilter)
      } else {
        this.loadData()
      }
    },
    camelCaseToNormal(text) {
      const result = text
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
        .replace(/^[a-z]/, function(match) {
          return match.toUpperCase()
        })
      return result
    },
  },
}
</script>

<template>
  <div>
    <div class="row mb-md-2">
      <div class="col-sm-6 col-md-6">
        <span>
          Risks found:
          <b>
            {{ rows }}
          </b>
          at
          <b>
            {{ new Date().toLocaleString() }}
          </b>
        </span>
      </div>

      <div class="col-sm-6 col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter text-md-right">
          <label class="d-inline-flex align-items-center">
            <b-form-input
              v-model="filter"
              type="search"
              placeholder="Text to search..."
              class="form-control form-control-sm ml-2"
            />
            <b-button size="sm" variant="light" @click="doSearch">
              Search
            </b-button>
            <b-button size="sm" variant="light" @click="configTable">
              *
            </b-button>
          </label>
        </div>
      </div>
    </div>
    <div class="table-responsive mb-0">
      <b-table
        :items="tableData"
        :fields="fields"
        :busy="isBusy"
        responsive="sm"
        :per-page="0"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :total-rows="totalRows"
        :pagination-options="{
          enabled: true,
        }"
      >
        <template v-if="showSearchByFields" v-slot:thead-top="data">
          <b-tr>
            <b-th v-for="field in fields">
              <template v-if="field.control === 'SearchInput'">
                <SearchInput
                  :desc="field.key"
                  :field="field.field"
                  text=""
                  @updated="fieldSearchChanged"
                />
              </template>
              <template v-else-if="field.control === 'activityDateTime'">
                <SearchDateTime
                  :desc="field.key"
                  :field="field.field"
                  text=""
                  @updated="datetimeSearchChanged"
                />
              </template>
              <template v-if="field.key === 'action'">
                <b-button @click="doSearchInput">
                  Search by fields
                </b-button>
              </template>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:table-busy>
          <div class="text-center">
            <br /><br />
            <b-spinner class="align-middle" />
            <strong>&nbsp;&nbsp;Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(riskLevel)="data">
          <template v-if="data.item.riskLevel === 'low'">
            <feather type="alert-circle" class="icon-xs icon-dual-success" />
          </template>
          <template v-else-if="data.item.riskLevel === 'medium'">
            <feather type="alert-triangle" class="icon-xs icon-dual-warning" />
          </template>
          <template v-else>
            <feather type="alert-octagon" class="icon-xs icon-dual-danger" />
          </template>
        </template>

        <template v-slot:cell(riskEventType)="data">
          {{ camelCaseToNormal(data.item.riskEventType) }}
        </template>

        <template v-slot:cell(riskState)="data">
          <span v-if="data.item.riskState === 'atRisk'" class="severity-high">
            {{ camelCaseToNormal(data.item.riskState) }}
          </span>
          <span v-else class="severity-low">
            {{ camelCaseToNormal(data.item.riskState) }}
          </span>
        </template>

        <template v-slot:cell(activityDateTime)="data">
          {{ new Date(data.item.activityDateTime).toLocaleString() }}
        </template>

        <template v-slot:cell(action)="data">
          <b-dropdown
            right
            variant="white"
            class="align-self-center"
            toggle-class="p-0"
          >
            <template v-slot:button-content>
              <feather
                type="chevron-down"
                class="align-middle"
                style="height:12px !important;width:20px !important;"
              />
            </template>
            <b-dropdown-item class="notify-item" @click="showDetails(data)">
              <feather
                type="search"
                class="icon-dual icon-xs mr-2 align-middle"
              />
              <span>Details</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Show&nbsp;
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            />&nbsp;entries
          </label>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <b-button
            v-if="showDownloadCSVButton"
            size="sm"
            variant="light"
            @click="downloadCSVFull"
          >
            Download CSV File (max 2000 entries)
          </b-button>
        </div>
      </div>
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @input="handlePageChange"
            />
          </ul>
        </div>
      </div>
    </div>
    <b-modal
      id="incident.incident_id"
      ref="modal-details"
      size="xl"
      title="Risk Details"
      :centered="true"
      :no-fade="true"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      ok-only
      @ok="modalIncidentDetailOk"
    >
      <template v-for="key in Object.keys(risk)">
        <div class="row">
          <div class="col-3">
            <span class="varname">{{ camelCaseToNormal(key) }}</span>
          </div>
          <template v-if="key === 'riskLevel_'"> </template>
          <template v-else-if="key === 'riskEventType_'"> </template>
          <template v-else-if="key === 'riskDetail'">
            <span style="margin-left:10px;" class="varcontent">{{
              camelCaseToNormal(risk[key])
            }}</span>
          </template>
          <template v-else-if="key === 'additionalInfo'">
            <template v-for="info in JSON.parse(risk[key])">
              <div v-if="info.Key === 'riskReasons'" class="col-3">
                <span class="varcontent">{{ info.Key }}:<br /></span>
                <ul
                  ><li style="margin-left:10px;" v-for="entry in info.Value">{{
                    entry
                  }}</li></ul
                >
              </div>
              <div
                v-else-if="
                  info.Key === 'mitreTechniques' && info.Value !== undefined
                "
                class="col-3"
              >
                <span class="varcontent">{{ info.Key }}<br /></span>
                <span style="margin-left:10px;">{{ info.Value }}</span>
              </div>
              <div
                v-else-if="info.Key === 'userAgent' && info.Value !== undefined"
                class="col-3"
              >
                <span class="varcontent">{{ info.Key }}<br /></span>
                <span style="margin-left:10px;">{{ info.Value }}</span>
              </div>
              <!-- <div v-else-if="info.Key === 'alertUrl' && info.Value !== null" class="col-3">
                {{ info }}
                <span>{{ info.Value }}</span>
              </div> -->
            </template>
          </template>
          <template v-else>
            <div class="col-9">
              <span class="varcontent">
                {{ risk[key] }}
              </span>
            </div>
          </template>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="table_config"
      ref="modal-table-config"
      size="xl"
      title="Events Table Config"
      :centered="true"
      :no-fade="true"
      ok-only
      @ok="modalTableDetaillOk"
    >
      <b-table :items="allFields" :fields="tableDetailFields" responsive="sm">
        <template v-slot:cell(visible)="data">
          <template v-for="field in allFields">
            <template v-if="data.item.label === field.label">
              <b-form-checkbox
                v-model="field.visible"
                name="check-button"
                switch
                @change="toggleVisibleColumn(data.item, field)"
              />
            </template>
          </template>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<style>
.incident-status {
  width: 15%;
}
.incident-description {
  width: 35%;
}
.varname {
  font-size: 1.2em;
  font-weight: 700;
}
.varcontent {
  font-size: 1.2em;
  font-weight: 200;
}
.severity-high {
  color: #dc001e;
}
.severity-medium {
  color: #feca00;
}
.severity-low {
  color: #01ad00;
}
</style>
